<div class="header">
    <h2>{{isEditingMode ? 'Edit':'Create'}}Contact Group</h2>
  </div>
  <mat-card>
    
    <div class="mat-elevation-z0">
      <h3 class="sub-heading inline-item">Contact Group Form</h3>
        <form [formGroup]="createContactGroupForm" (ngSubmit)="createContactGroup()" class="contact-group-form">
          <div class="inline-item">
            <mat-form-field appearance="outline" class="full-width">
              <input matInput formControlName="name" placeholder="Contact Group Name" />
            </mat-form-field>
          </div>
          <div class="inline-button">
            <button mat-flat-button type="submit" color="primary"
            [disabled]="createContactGroupForm.invalid">{{isEditingMode ? 'Save' : 'Create'}}
            Contact Group</button>
          </div>
        </form>
        <br />
        <div class="contacts-wrapper">
  
        <div class="mat-elevation-z0">
          <!-- <mat-expansion-panel [expanded]="true"> -->
            <!-- <mat-expansion-panel-header> -->
              <!-- <mat-panel-title> -->
                <!-- Customers -->
              <!-- </mat-panel-title> -->
              <!-- <mat-panel-description> -->
                <!-- Choose Customers -->
              <!-- </mat-panel-description> -->
            <!-- </mat-expansion-panel-header> -->
            <div class="table-container">
              <table mat-table [dataSource]="contactsList?.results" matTableResponsive>
                <ng-container matColumnDef="checkbox">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let contact">
                    <mat-icon *ngIf="selectedContactsIDs.indexOf(contact.id) == -1" (click)="addContact(contact)" color="primary" class="icon">add</mat-icon>
                    <mat-icon *ngIf="selectedContactsIDs.indexOf(contact.id) != -1" color="primary" class="icon">check</mat-icon>
                  </td>
                </ng-container>
                <ng-container matColumnDef="number">
                  <th mat-header-cell *matHeaderCellDef> No. </th>
                  <td mat-cell *matCellDef="let i=index"> {{ i + 1}} </td>
                </ng-container>

                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef> Email </th>
                  <td mat-cell *matCellDef="let contact"> 
                    {{contact.email}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef> Name </th>
                  <td mat-cell *matCellDef="let contact"> 
                    {{contact.name}}
                  </td>
                </ng-container>
  
  
                <tr mat-header-row *matHeaderRowDef="contactsDisplayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: contactsDisplayedColumns;"></tr>
              </table>
              <mat-paginator [length]="contactsList?.count" (page)="onPaginateChange($event)" [pageIndex]="pageIndex"
              [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions">
            </mat-paginator>
            </div>
          <!-- </mat-expansion-panel> -->
        </div>
        <div class="mat-elevation-z0">
          <h3>Selected Contacts({{selectedContacts.length}})</h3>
          <br />
        <table mat-table [dataSource]="selectedContacts" style="margin-top: 7px" matTableResponsive #selectedTable>
          <ng-container matColumnDef="checkbox">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let i=index">
              <mat-icon (click)="removeContact(i)" color="accent" class="icon">remove</mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="number">
            <th mat-header-cell *matHeaderCellDef> No. </th>
            <td mat-cell *matCellDef="let i=index"> {{ i + 1}} </td>
          </ng-container>
  
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Name </th>
            <td mat-cell *matCellDef="let contact">{{contact.name}}</td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef> Email </th>
            <td mat-cell *matCellDef="let contact"> 
              {{contact.email}}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="selectedContactsDisplayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: selectedContactsDisplayedColumns;"></tr>
        </table>
        </div>
      </div>
  
    </div>
  </mat-card>
  